/**
 * Perche' un ordine del negozio e' sulla sua scheda (orders.client_match_method, scritto da flusia-core
 * planners/customers/match.ts). Il cliente si riconosce da account, email, P.IVA/CF o telefono, mai dal
 * nome: ordini con nomi diversi e la stessa email (o lo stesso utente del sito) vanno sulla stessa scheda.
 */
const MATCH_TEXT: Readonly<Record<string, string>> = Object.freeze({
  external_ref: 'Cliente del negozio già collegato a questa scheda (stesso account o stessa email)',
  email: 'Riconosciuto dall\'email',
  tax_id: 'Riconosciuto da P.IVA o codice fiscale',
  phone: 'Riconosciuto dal telefono',
  created: 'Scheda creata da questo ordine',
  service_client: 'Ordine senza email né telefono: messo sul cliente «Vendita al banco»',
  ambiguous: 'Abbinamento incerto: si sceglie in E-commerce → Negozi → il negozio → Clienti',
  manual: 'Cliente scelto a mano in Flusia',
});

/** Frase per il dettaglio ordine; null per gli ordini manuali o senza dato. */
export function orderClientMatchText(method: string | null | undefined): string | null {
  return method ? MATCH_TEXT[method] ?? null : null;
}

/** Pagina della scheda: i Lead stanno in Lead, gli altri in Clienti. */
export function clientCardPath(clientId: string, isLead: boolean): string {
  return isLead ? `/leads/${clientId}` : `/clients/${clientId}`;
}
